// not the best approach, but it works

export const getFlagEmoji = (countryCode) => {
  const aliases = {
    en: 'gb',
  };

  if (aliases[countryCode]) {
    countryCode = aliases[countryCode];
  }

  if (!countryCode || countryCode.length !== 2) {
    return '';
  }
  
  return String.fromCodePoint(...countryCode
      .toUpperCase()
      .split('')
      .map(char => 127397 + char.charCodeAt(0)));
}; 